
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/smb-shipping",
      function () {
        return require("private-next-pages/smb-shipping.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/smb-shipping"])
      });
    }
  